import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import { portalTarget } from './react-portals';

var PortalTargetDefault =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PortalTargetDefault, _PureComponent);

  function PortalTargetDefault() {
    _classCallCheck(this, PortalTargetDefault);

    return _possibleConstructorReturn(this, _getPrototypeOf(PortalTargetDefault).apply(this, arguments));
  }

  _createClass(PortalTargetDefault, [{
    key: "render",
    value: function render() {
      return React.createElement("div", null, this.props.children);
    }
  }]);

  return PortalTargetDefault;
}(PureComponent);

var PortalTarget =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(PortalTarget, _PureComponent2);

  function PortalTarget(props) {
    var _this;

    _classCallCheck(this, PortalTarget);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PortalTarget).call(this, props));
    _this.Target = portalTarget(props.name)(props.children || PortalTargetDefault);
    return _this;
  }

  _createClass(PortalTarget, [{
    key: "render",
    value: function render() {
      var Target = this.Target;
      return React.createElement(Target, null);
    }
  }]);

  return PortalTarget;
}(PureComponent);

_defineProperty(PortalTarget, "propTypes", {
  /**
   * name of the portal, used as a unique identifier
   */
  name: propTypes.string
});

export default PortalTarget;